export default "__VITE_ASSET__98b4c8b0__"